import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { HeadingType } from '@freelancer/ui/heading';
import { Margin } from '@freelancer/ui/margin';
import {
  FontColor,
  FontType,
  FontWeight,
  TextSize,
  TextTransform,
} from '@freelancer/ui/text';
@Component({
  selector: 'app-project-equipment',
  template: `
    <fl-bit class="EquipmentFieldLabel">
      <fl-heading
        i18n="Post Job Page local project equipment field header label"
        [flMarginBottom]="Margin.XSMALL"
        [flMarginRight]="Margin.XXXSMALL"
        [headingType]="HeadingType.H3"
        [size]="TextSize.MID"
      >
        Do you need specific equipment or tools from the freelancer?
        <fl-text
          [color]="FontColor.MID"
          [flMarginBottom]="Margin.XSMALL"
          [fontType]="FontType.SPAN"
          [size]="TextSize.XXXSMALL"
          [textTransform]="TextTransform.UPPERCASE"
          [weight]="FontWeight.BOLD"
        >
          Optional
        </fl-text>
      </fl-heading>
    </fl-bit>
    <fl-bit [flMarginBottom]="Margin.MID">
      <fl-multi-select
        flTrackingLabel="FocusIn"
        i18n-placeholder="Post Job Page form equipment field placeholder"
        i18n-secondaryPlaceholder="
           Post Job Page form equipment field placeholder
        "
        placeholder="Enter equipment here..."
        secondaryPlaceholder="Enter equipment here..."
        [allowCustomEntry]="true"
        [control]="control"
        [maxLength]="100"
      >
      </fl-multi-select>
    </fl-bit>
  `,
})
export class EquipmentComponent {
  FontColor = FontColor;
  FontType = FontType;
  FontWeight = FontWeight;
  HeadingType = HeadingType;
  Margin = Margin;
  TextSize = TextSize;
  TextTransform = TextTransform;

  @Input() control: FormControl;
}
